import { useLocation, useSearchParams } from "react-router-dom";

const C = {
  green: "#059669",
  greenDark: "#047857",
  greenBg: "#ECFDF5",
  greenBorder: "#A7F3D0",
  ink: "#111827",
  body: "#374151",
  sub: "#6B7280",
  line: "#E5E7EB",
  bg: "#F9FAFB",
};

const STATUS_TABS = [
  { key: null, label: "전체" },
  { key: "0", label: "매칭중" },
  { key: "1", label: "매칭완료" },
];

const SCOPE_TABS = [
  { key: "0", label: "내 견적" },
  { key: "1", label: "모든 견적" },
];

const FilterListMenu = ({ hideScope = false }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const currentStatus = searchParams.get("status");
  const currentScope = searchParams.get("filter") ?? "0";

  const initPage = () => {
    sessionStorage.setItem(`page_${location.pathname}`, "1");
    sessionStorage.setItem(`pageIndex_${location.pathname}`, "1");
    window.location.reload();
  };

  const handleStatusChange = (newStatus) => {
    const next = new URLSearchParams(searchParams);
    if (newStatus === null || newStatus === undefined) next.delete("status");
    else next.set("status", String(newStatus));
    setSearchParams(next);
    initPage();
  };

  const handleScopeChange = (newScope) => {
    const next = new URLSearchParams(searchParams);
    next.set("filter", String(newScope));
    setSearchParams(next);
    initPage();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        userSelect: "none",
      }}
    >
      {/* 상태 칩 */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {STATUS_TABS.map((t) => {
          const active =
            t.key === null ? currentStatus === null : currentStatus === t.key;
          return (
            <button
              key={String(t.key)}
              type="button"
              onClick={() => handleStatusChange(t.key)}
              style={{
                padding: "8px 16px",
                borderRadius: 9999,
                fontSize: 14,
                fontWeight: active ? 700 : 500,
                color: active ? "#fff" : C.body,
                background: active ? C.greenDark : "#fff",
                border: `1px solid ${active ? C.greenDark : C.line}`,
                cursor: "pointer",
                transition: "all 0.15s ease",
                whiteSpace: "nowrap",
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Scope 세그먼트 */}
      {!hideScope && (
        <div
          role="tablist"
          style={{
            display: "inline-flex",
            padding: 4,
            background: C.bg,
            borderRadius: 10,
            border: `1px solid ${C.line}`,
          }}
        >
          {SCOPE_TABS.map((t) => {
            const active = currentScope === t.key;
            return (
              <button
                key={t.key}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => handleScopeChange(t.key)}
                style={{
                  padding: "6px 14px",
                  borderRadius: 7,
                  fontSize: 13,
                  fontWeight: active ? 700 : 500,
                  color: active ? C.ink : C.sub,
                  background: active ? "#fff" : "transparent",
                  boxShadow: active ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
                  border: "none",
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  whiteSpace: "nowrap",
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterListMenu;
